export type MenuItem = {
  label: string;
  icon?: string;
  path?: string;
  subItems?: MenuItem[];
};

export const menuItems: MenuItem[] = [
  {
    label: "Identifiers",
    icon: "badge",
    path: "/compliance/identifiers",
  },
  {
    label: "Variants/Configurations",
    icon: "interests",
    path: "/compliance/variants",
  },
  {
    path: "/compliance/lifecycle",
    label: "Lifecycle",
    icon: "compost",
  },
  {
    label: "Use and purpose",
    subItems: [
      {
        label: "User",
        icon: "account_circle",
        path: "/compliance/user",
      },
    ],
  },
  {
    label: "General aspects",
    subItems: [
      {
        label: "Functional elements",
        icon: "extension",
        path: "/compliance/functional-elements",
      },
    ],
  },
  {
    label: "Specific properties",
    subItems: [
      /* {
        label: "Size",
        icon: "straighten",
      },
      {
        label: "Packaging",
        icon: "featured_seasonal_and_gifts",
      },
      {
        label: "Consumables",
        icon: "attach_file",
      }, */

      {
        label: "Contact",
        icon: "massage",
        path: "/compliance/contact-profiles",
      },
      /* {
        label: "Substances",
        icon: "science",
      },
      {
        label: "Radiation",
        icon: "radiology",
      },
      {
        label: "Energy",
        icon: "solar_power",
      },
      {
        label: "Calibration",
        icon: "balance",
      }, */
      {
        label: "Microbiological states",
        icon: "coronavirus",
        subItems: [
          {
            path: "/compliance/microbiology/sterilization",
            label: "Sterilization",
            icon: "microwave",
          },
          {
            path: "/compliance/microbiology/disinfection",
            label: "Disinfection",
            icon: "coronavirus",
          },
          {
            path: "/compliance/microbiology/cleaning",
            label: "Cleaning",
            icon: "water_drop",
          },
        ],
      },
      /* {
        label: "Concomitant treatments",
        icon: "vaccines",
      },
      {
        label: "Reusability",
        icon: "recycling",
      },
      {
        label: "Invasiveness",
        icon: "surgical",
      },
      {
        label: "Portability",
        icon: "medical_services",
      },
      {
        label: "Nanomaterials",
        icon: "grain",
      },
      {
        label: "Measuring function",
        icon: "measuring_tape",
      },
      {
        label: "Personalization",
        icon: "self_care",
      }, */
    ],
  },
];
